var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.visible)?_c('vue-highcharts',{ref:"lineCharts",attrs:{"options":_vm.options,"id":"high-chart"}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }